module.exports = __webpack_public_path__ + "icon_telecommunication.svg?a595b1b195a21fffa3c3b9c43859cce3";


//////////////////
// WEBPACK FOOTER
// ./src/img/domaine_activite/icon_telecommunication.svg
// module id = 119
// module chunks = 0